export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
    brand: {
      20: "#0099a233",
      50: "#cbbff8",
      100: "#876cea",
      200: "#0099a2",
      300: "#542de1",
      400: "#4a25d0",
      500: "#0099a2",
      600: "#300eaa",
      700: "#1c0377",
      800: "#130156",
      900: "#0e0042",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        fontFamily: '"Oxygen", serif',
      },
      "*::placeholder": {
        color: "gray.400",
      },
      html: {
        fontFamily: '"Oxygen", serif',
      },
    }),
  },
};
